/**
 * useAgentActivity — React binding for the shared agent-operations store.
 *
 * Returns the session list newest-first (optionally workspace-scoped) and
 * re-renders whenever the store ingests a live or replayed event.
 */
import { useSyncExternalStore } from "react";
import {
  agentActivityVersion,
  getAgentSessions,
  subscribeAgentActivity,
  type AgentSessionState,
} from "./agent-activity-store.js";

export function useAgentActivity(workspaceId?: string | null): AgentSessionState[] {
  useSyncExternalStore(subscribeAgentActivity, agentActivityVersion, agentActivityVersion);
  return getAgentSessions(workspaceId);
}

export function useActiveAgentSessions(workspaceId?: string | null): AgentSessionState[] {
  return useAgentActivity(workspaceId).filter(
    (s) => s.status === "running" || s.status === "waiting" || s.status === "queued" || s.status === "paused",
  );
}
